﻿import { BaseRequestOptions } from '@angular/http'

export class AppRequestOptions extends BaseRequestOptions {

    //override default angular settings
    //use it in appmodule
    constructor() {
        super();
        this.withCredentials = true;
        this.headers.set('Cache-Control', 'no-cache');
        this.headers.set('Pragma', 'no-cache');
    }

}